import React from "react";
import styles from "./imageDragPreview.scss";

const ImageDragPreview = ({ style, item }) => (
  <img
    alt="preview"
    className={styles.image}
    style={{ opacity: 0.5, zIndex: 2, ...style }}
    src={item.imageUrl}
  ></img>
);

export default ImageDragPreview;



// WEBPACK FOOTER //
// ./src/components/FormControls/PhotoUploader/MultiplePhotos/ImageCard/ImageDragPreview/index.tsx